import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpConfigInterceptor } from './app/_helper/httpconfig.interceptor';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './app/services/app-title.strategy';

registerLocaleData(en);

// if (process.env['NODE_ENV'] === 'production') {
//   enableProdMode();
// }

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: NZ_I18N, useValue: en_US },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
  ],
}).catch(err => console.error(err));


